import * as yup from 'yup'

const SchemaValidations = yup.object().shape({
  name: yup.string().nullable(),
  email: yup.string().nullable(),
  type: yup
    .object({
      label: yup.string(),
      value: yup.string(),
    })
    .nullable(),
  typeValue: yup.string().nullable(),
  dteType: yup.string().nullable(),
  startDate: yup.date().nullable(),
  endDate: yup.date().nullable(),
})

export default SchemaValidations
